"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const CreativeFastStart_1 = require("./CreativeFastStart");
const File_1 = require("./File");
class Creative {
    constructor({ id, fastStart, file }) {
        this.asFileName = () => `creative${this.id}.${this.file.extension}`;
        this.toJSON = () => ({
            id: this.id,
            fastStart: this.fastStart && this.fastStart.toJSON(),
            file: this.file.toJSON(),
        });
        this.id = id;
        this.fastStart = fastStart;
        this.file = file;
    }
}
Creative.fromJSON = (json) => {
    const { id, fastStart, file } = Object.assign({}, json);
    const _fastStart = fastStart ? CreativeFastStart_1.default.fromJSON(fastStart) : undefined;
    if (typeof id !== 'string')
        throw new Error('.id must be a string');
    return new Creative({ id, fastStart: _fastStart, file: File_1.default.fromJSON(file) });
};
exports.default = Creative;
